import { fetchInstalledExtensionList } from '@lumapps/marketplace/api/installedExtensions';
import { ExtensionStatus } from '@lumapps/marketplace/constants';

/////////////////////////////

function ExtensionWidgetService($timeout, LumsitesBaseService, WidgetFactory, Instance) {
    'ngInject';

    const service = LumsitesBaseService.createLumsitesBaseService(WidgetFactory, {
        autoInit: false,
        objectIdentifier: 'uid',
    });

    service.initialized = false;
    service.extensions = [];

    /** In-flight request to fetch the installed extension list, shared across concurrent callers. */
    let extensionListRequest = null;

    /**
     * Retrieve only the extensions that has been enabled by admin.
     * The fetch is deduplicated: concurrent calls share the same in-flight request.
     */
    function getEnabledExtensions() {
        if (service.initialized) {
            return Promise.resolve(service.extensions);
        }

        if (extensionListRequest) {
            return extensionListRequest;
        }

        const siteId = Instance.getCurrentInstanceId();

        extensionListRequest = fetchInstalledExtensionList({
            maxResults: '100',
            categories: ['widget'],
            statuses: [ExtensionStatus.live],
            siteId,
        }).then((data) => {
            service.extensions = data.items;
            service.initialized = true;
            extensionListRequest = null;
            return service.extensions;
        });

        return extensionListRequest;
    }

    async function getEnabledExtension(id) {
        const enabledExtensions = await getEnabledExtensions();
        return enabledExtensions.find((extension) => extension.id === id);
    }

    /////////////////////////////

    /////////////////////////////
    //                         //
    //          Redux          //
    //                         //
    /////////////////////////////

    service.getEnabledExtension = getEnabledExtension;
    service.getEnabledExtensions = getEnabledExtensions;

    /////////////////////////////

    /**
     * Initialize the service.
     */
    service.init = function init(cb) {
        $timeout(async () => {
            await getEnabledExtensions();
            cb();
        });
    };

    /////////////////////////////

    return service;
}

/////////////////////////////

angular.module('Services').service('ExtensionWidget', ExtensionWidgetService);

/////////////////////////////

export { ExtensionWidgetService };
